/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */

/**
 * Types of Addresses for Organizations.
 */
export type AddressTypes = typeof AddressTypes[keyof typeof AddressTypes];


export const AddressTypes = {
  Branch: 'Branch',
  Customer: 'Customer',
} as const;
